import { PageId } from 'constants/pages'
import { TPageConfig } from 'models/common.model'
// import { HeaderId } from 'nove8/constants/root-constants'
import { THEMES } from 'root-constants'
import { PageIdWoofzWS2 } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_WS2: Record<
  Exclude<PageIdWoofzWS2, PageIdWoofzWS2.ACCOUNT_NOVE8>,
  TPageConfig
> = {
  [PageId.SEX_WS2]: {
    id: PageId.SEX_WS2,
    hasHeaderBackButton: true,
    hasHeader: true,
    progressBar: 'controlled',
    theme: THEMES.VARIANT_WELLNESS,
  },
  [PageId.URGE_WS2]: {
    id: PageId.URGE_WS2,
    hasHeaderBackButton: true,
    hasHeader: true,
    theme: THEMES.URGE,
  },
  [PageId.AGE_WS2]: {
    id: PageId.AGE_WS2,
    hasHeader: true,
    theme: THEMES.VARIANT_WELLNESS,
  },
  [PageId.BREED_WS2]: {
    id: PageId.BREED_WS2,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    theme: THEMES.VARIANT_WELLNESS,
  },
  [PageId.URGE_WS2_2]: {
    id: PageId.URGE_WS2_2,
    hasHeader: true,
    hasHeaderBackButton: true,
    theme: THEMES.VARIANT_WELLNESS,
  },
  [PageId.WORRIES_WS2]: {
    id: PageId.WORRIES_WS2,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    theme: THEMES.VARIANT_WELLNESS,
  },
  [PageId.URGE_WS2_3]: {
    id: PageId.URGE_WS2_3,
    hasHeader: true,
    hasHeaderBackButton: true,
    theme: THEMES.VARIANT_WELLNESS,
  },
  [PageId.LICK_PAWS_WS2]: {
    id: PageId.LICK_PAWS_WS2,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    theme: THEMES.VARIANT_WELLNESS,
  },
  [PageId.DRAG_BOTTOM_WS2]: {
    id: PageId.DRAG_BOTTOM_WS2,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    theme: THEMES.VARIANT_WELLNESS,
  },
  [PageId.CHECK_EARS_WS2]: {
    id: PageId.CHECK_EARS_WS2,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    theme: THEMES.VARIANT_WELLNESS,
  },
  [PageId.WASH_TEETH_WS2]: {
    id: PageId.WASH_TEETH_WS2,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    theme: THEMES.VARIANT_WELLNESS,
  },
  [PageId.CLEAN_EYES_WS2]: {
    id: PageId.CLEAN_EYES_WS2,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    theme: THEMES.VARIANT_WELLNESS,
  },
  [PageId.BREATH_WS2]: {
    id: PageId.BREATH_WS2,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    theme: THEMES.VARIANT_WELLNESS,
  },
  [PageId.WEIGHT_WS2]: {
    id: PageId.WEIGHT_WS2,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    theme: THEMES.VARIANT_WELLNESS,
  },
  [PageId.FEED_WS2]: {
    id: PageId.FEED_WS2,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    theme: THEMES.VARIANT_WELLNESS,
  },
  [PageId.FOOD_PORTIONS_WS2]: {
    id: PageId.FOOD_PORTIONS_WS2,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    theme: THEMES.VARIANT_WELLNESS,
  },
  [PageId.URGE_WS2_4]: {
    id: PageId.URGE_WS2_4,
    hasHeader: true,
    hasHeaderBackButton: true,
    theme: THEMES.VARIANT_WELLNESS,
  },
  [PageId.WATER_WS2]: {
    id: PageId.WATER_WS2,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    theme: THEMES.VARIANT_WELLNESS,
  },
  [PageId.CLEAN_BOWLS_WS2]: {
    id: PageId.CLEAN_BOWLS_WS2,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    theme: THEMES.VARIANT_WELLNESS,
  },
  [PageId.COAT_WS2]: {
    id: PageId.COAT_WS2,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    theme: THEMES.VARIANT_WELLNESS,
  },
  [PageId.WALK_WS2]: {
    id: PageId.WALK_WS2,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    theme: THEMES.VARIANT_WELLNESS,
  },
  [PageId.URGE_WS2_5]: {
    id: PageId.URGE_WS2_5,
    hasHeader: true,
    hasHeaderBackButton: true,
    theme: THEMES.VARIANT_WELLNESS,
  },
  [PageId.VET_WS2]: {
    id: PageId.VET_WS2,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    theme: THEMES.VARIANT_WELLNESS,
  },
  [PageId.PROTECT_WS2]: {
    id: PageId.PROTECT_WS2,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    theme: THEMES.VARIANT_WELLNESS,
  },
  [PageId.CHRONIC_WS2]: {
    id: PageId.CHRONIC_WS2,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    theme: THEMES.VARIANT_WELLNESS,
  },
  [PageId.BEHAVIOR_CHANGES_WS2]: {
    id: PageId.BEHAVIOR_CHANGES_WS2,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    theme: THEMES.VARIANT_WELLNESS,
  },
  [PageId.URGE_WS2_6]: {
    id: PageId.URGE_WS2_6,
    hasHeader: true,
    hasHeaderBackButton: true,
    theme: THEMES.VARIANT_WELLNESS,
  },
  [PageId.ITCH_WS2]: {
    id: PageId.ITCH_WS2,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    theme: THEMES.VARIANT_WELLNESS,
  },
  [PageId.ALONE_WS2]: {
    id: PageId.ALONE_WS2,
    hasHeader: true,
    progressBar: 'controlled',
    hasHeaderBackButton: true,
    theme: THEMES.VARIANT_WELLNESS,
  },
  [PageId.URGE_WS2_7]: {
    id: PageId.URGE_WS2_7,
    hasHeader: true,
    hasHeaderBackButton: true,
    theme: THEMES.VARIANT_WELLNESS,
  },
  [PageId.SLEEP_WS2]: {
    id: PageId.SLEEP_WS2,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    theme: THEMES.VARIANT_WELLNESS,
  },
  [PageId.SLEEPING_ENV_WS2]: {
    id: PageId.SLEEPING_ENV_WS2,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    theme: THEMES.VARIANT_WELLNESS,
  },
  [PageId.URGE_WS2_8]: {
    id: PageId.URGE_WS2_8,
    hasHeader: true,
    hasHeaderBackButton: true,
    theme: THEMES.VARIANT_WELLNESS,
  },
  [PageId.DOG_NAME_WS2]: {
    id: PageId.DOG_NAME_WS2,
    hasHeader: true,
    hasHeaderBackButton: true,
    theme: THEMES.VARIANT_WELLNESS,
  },
  [PageId.SPEND_TIME_WS2]: {
    id: PageId.SPEND_TIME_WS2,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    theme: THEMES.VARIANT_WELLNESS,
  },
  [PageId.PREPARE_FLOW_WS2]: {
    id: PageId.PREPARE_FLOW_WS2,
    hasHeaderBackButton: true,
    hasHeader: true,
    theme: THEMES.VARIANT_WELLNESS,
  },
  [PageId.EMAIL_WS2]: {
    id: PageId.EMAIL_WS2,
    hasHeader: true,
    hasHeaderBackButton: true,
    theme: THEMES.VARIANT_WELLNESS,
  },
  [PageId.NEWSLETTER_URGE_WS2]: {
    id: PageId.NEWSLETTER_URGE_WS2,
    hasHeader: true,
    hasHeaderBackButton: true,
    theme: THEMES.VARIANT_WELLNESS,
  },
  [PageId.URGE_WS2_9]: {
    id: PageId.URGE_WS2_9,
    hasHeader: true,
    theme: THEMES.VARIANT_WELLNESS,
  },
  [PageId.GIFT_WS2]: {
    id: PageId.GIFT_WS2,
    hasHeader: true,
    theme: THEMES.VARIANT_WELLNESS,
  },
  [PageId.WELCOME_WS2]: {
    id: PageId.WELCOME_WS2,
    hasHeader: true,
    theme: THEMES.VARIANT_WELLNESS,
  },
  [PageId.SUBSCRIPTIONS_WS2]: {
    id: PageId.SUBSCRIPTIONS_WS2,
  },
  [PageId.CANCEL_OFFER_WS2]: {
    id: PageId.CANCEL_OFFER_WS2,
  },
  [PageId.CHAT_UPSELL_WS2]: {
    id: PageId.CHAT_UPSELL_WS2,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.UPSELL_WS2]: {
    id: PageId.UPSELL_WS2,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.DOWNLOAD_WS2]: {
    id: PageId.DOWNLOAD_WS2,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
}
